import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=097be34c&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"
import style0 from "./MainFooter.vue?vue&type=style&index=0&id=097be34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097be34c",
  null
  
)


    import installComponents from "!/home/gitlab-runner/builds/_LQxgyuP/0/skolkovo/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BImgLazy, BSkeleton, BRow, BSkeletonWrapper, BButton, BModal} from 'bootstrap-vue'
    installComponents(component, {BImgLazy, BSkeleton, BRow, BSkeletonWrapper, BButton, BModal})
    

export default component.exports